// src/pages/MeoVat.js
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { fetchData, addData, updateData, deleteData, guiAnh } from "../services/api";
import { useThongBao, ThongBao, DangTai, hoiXoa } from "../vo";
import AnhCoKhoa from "../components/AnhCoKhoa";
import XemAnh from "../components/XemAnh";
import { thuNhoAnh, veDungLuong } from "../utils/thuNhoAnh";
import {
  PHAN_LOAI,
  tenLoai,
  bieuTuongLoai,
  khopTim,
  laDauMuc,
  tachLink,
  laLinkHopLe,
  KHUNG_MON_AN,
  NGAY_KHEN,
} from "../utils/meoVat";

// ============================================================
// 💡 SỔ TAY MẸO VẶT (Đợt N6, 15/09/2026)
// ------------------------------------------------------------
// Chân dung 4.4. Anh duyệt mockup `quan-gia-docs/mockup/N6_meo_vat.html`.
//
// Ba màn trong một trang:
//   /meo-vat         danh sách: ô tìm (MV8) · nút lọc loại (MV3) · mới nhất ở trên (Đ2)
//   /meo-vat/:id     xem một mẹo — có đường link riêng để khung "Biết gì chưa?"
//                    trên Bảng tin bấm vào là tới thẳng mẹo đó
//   ➕ Viết / ✏️ Sửa  biểu mẫu (không đổi đường link — bấm Thôi là về chỗ cũ)
//
// AI LÀM ĐƯỢC GÌ (MV2): ai đăng nhập cũng xem, viết. Sửa, xoá, gắn ảnh: người
// viết + chủ nhà. Nút ✏️ 🗑️ ẩn với người khác chỉ là phép lịch sự — máy chủ
// chặn thật (403).
//
// GÓC VUI — hướng A (15/09): viết xong được CẢM ƠN ngay (màn ⑤), và mẹo lên
// "📢 Biết gì chưa?" 3 ngày. ⚠️ Không đếm "bạn đã góp mấy mẹo", không xếp hạng
// (chân dung 5.1, 5.4).
//
// ⚠️ Component con nằm NGOÀI hàm MeoVat — bài học
// docs/bai-hoc/2026-09-07-06_ham-trong-ham-lam-mat-con-tro.md (ô nhập mất con
// trỏ sau mỗi chữ gõ).
// ============================================================

const FORM_TRONG = { tieu_de: "", phan_loai: "", noi_dung: "", link: "" };

// ----- Nội dung mẹo: chữ thường giữ xuống dòng, đầu mục in đậm, link bấm được (Đ3, MV6) -----
function NoiDungMeo({ chu }) {
  if (!chu) return null;
  return (
    <div className="mv-noi-dung">
      {chu.split("\n").map((dong, i) => {
        const manh = tachLink(dong).map((m, j) =>
          m.link ? (
            <a key={j} href={m.link} target="_blank" rel="noopener noreferrer" className="mv-link">
              {m.link}
            </a>
          ) : (
            <React.Fragment key={j}>{m.chu}</React.Fragment>
          ),
        );
        if (dong.trim() === "") return <div key={i} className="mv-dong-trong" />;
        return laDauMuc(dong) ? (
          <strong key={i} className="mv-dau-muc">{manh}</strong>
        ) : (
          <div key={i}>{manh}</div>
        );
      })}
    </div>
  );
}

// ----- Một thẻ trong danh sách -----
function TheMeo({ m, onMo }) {
  const coAnh = m.anh_id && !m.anh_da_don;
  return (
    <li>
      <button className="mv-the" onClick={onMo}>
        {coAnh ? (
          <AnhCoKhoa anhId={m.anh_id} moTa={m.tieu_de} className="mv-anh-nho" />
        ) : (
          <span className="mv-anh-nho mv-anh-trong" aria-hidden="true">{bieuTuongLoai(m.phan_loai)}</span>
        )}
        <span className="mv-the-chu">
          <strong className="mv-the-tieu-de">{m.tieu_de}</strong>
          <span className="mv-the-phu">
            {tenLoai(m.phan_loai)} · {m.ten_nguoi_viet || "?"} · {m.ngay_viet}
          </span>
        </span>
      </button>
    </li>
  );
}

// ----- Biểu mẫu Viết / Sửa -----
function FormMeo({ form, onDoi, anhCu, tepMoi, onChonTep, boAnhCu, onBoAnhCu, dangGui, onLuu, onThoi, laSua }) {
  const [xemTruoc, setXemTruoc] = useState(null);

  useEffect(() => {
    if (!tepMoi) {
      setXemTruoc(null);
      return undefined;
    }
    const url = URL.createObjectURL(tepMoi);
    setXemTruoc(url);
    return () => URL.revokeObjectURL(url);
  }, [tepMoi]);

  // Đ4 — dán khung món ăn. Ô đã có chữ thì hỏi trước, không ghi đè im lặng.
  const danKhung = () => {
    if (form.noi_dung.trim() !== "" &&
        !window.confirm("Ô nội dung đang có chữ.\n\nThay bằng khung món ăn 6 phần? Chữ đang có sẽ mất.")) {
      return;
    }
    onDoi("noi_dung", KHUNG_MON_AN);
  };

  const conAnhCu = anhCu && !boAnhCu && !tepMoi;

  return (
    <form
      className="mv-form"
      onSubmit={(e) => {
        e.preventDefault();
        onLuu();
      }}
    >
      <label className="mv-nhan">
        <span>
          Tiêu đề <span className="mv-nhan-phu">(bắt buộc)</span>
        </span>
        <input
          type="text"
          value={form.tieu_de}
          onChange={(e) => onDoi("tieu_de", e.target.value)}
          placeholder="Ví dụ: Tẩy vết dầu mỡ trên áo"
          maxLength={150}
          className="mv-o"
          autoFocus={!laSua}
        />
      </label>

      <label className="mv-nhan">
        Phân loại
        <select value={form.phan_loai} onChange={(e) => onDoi("phan_loai", e.target.value)} className="mv-o">
          <option value="">— chọn một loại —</option>
          {PHAN_LOAI.map((p) => (
            <option key={p.ma} value={p.ma}>{p.ten}</option>
          ))}
        </select>
      </label>

      <div className="mv-nhan">
        <span>
          Nội dung <span className="mv-nhan-phu">(không bắt buộc)</span>
        </span>
        {form.phan_loai === "nau_an" && (
          <button type="button" className="mv-nut-khung" onClick={danKhung}>
            📋 Dán khung món ăn
          </button>
        )}
        <textarea
          value={form.noi_dung}
          onChange={(e) => onDoi("noi_dung", e.target.value)}
          placeholder={
            form.phan_loai === "nau_an"
              ? "Bấm 📋 Dán khung món ăn ở trên — có sẵn 6 phần, chỉ việc điền"
              : "Viết cách làm. Xuống dòng thoải mái, dòng bắt đầu bằng 1. 2. 3. sẽ in đậm."
          }
          maxLength={10000}
          className="mv-o mv-o-dai"
        />
      </div>

      <div className="mv-nhan">
        <span>
          Ảnh <span className="mv-nhan-phu">(không bắt buộc · một tấm)</span>
        </span>
        <div className="mv-hang-anh">
          {xemTruoc && <img src={xemTruoc} alt="Ảnh vừa chọn" className="mv-anh-nho" />}
          {conAnhCu && <AnhCoKhoa anhId={anhCu} moTa="Ảnh của mẹo" className="mv-anh-nho" />}
          {/* Không kèm `capture`: để điện thoại hỏi "Chụp ảnh hay Chọn từ thư viện" (N5). */}
          <label className={`ct-nut-gan-anh ${dangGui ? "ct-nut-tat" : ""}`}>
            📷 {xemTruoc || conAnhCu ? "Đổi ảnh khác" : "Gắn ảnh"}
            <input
              type="file"
              accept="image/*"
              disabled={Boolean(dangGui)}
              onChange={(e) => {
                const tep = e.target.files && e.target.files[0];
                e.target.value = "";
                if (tep) onChonTep(tep);
              }}
            />
          </label>
          {(xemTruoc || conAnhCu) && (
            <button type="button" className="ct-nut-bo-anh" onClick={onBoAnhCu} disabled={Boolean(dangGui)}>
              ✕ bỏ ảnh
            </button>
          )}
        </div>
      </div>

      <label className="mv-nhan">
        <span>
          Link <span className="mv-nhan-phu">(không bắt buộc — ví dụ video YouTube)</span>
        </span>
        <input
          type="url"
          value={form.link}
          onChange={(e) => onDoi("link", e.target.value)}
          placeholder="https://…"
          maxLength={500}
          className="mv-o"
        />
      </label>

      <div className="mv-hang-nut">
        <button type="submit" className="nut nut-xanh mv-nut-to" disabled={Boolean(dangGui)}>
          {dangGui || (laSua ? "Lưu thay đổi" : "Lưu mẹo")}
        </button>
        <button type="button" className="nut nut-xam mv-nut-to" onClick={onThoi} disabled={Boolean(dangGui)}>
          Thôi
        </button>
      </div>
    </form>
  );
}

// ----- 🎉 Lời cảm ơn ngay sau khi góp mẹo (mockup màn ⑤) -----
function LoiCamOn({ ten, onDong }) {
  return (
    <div className="mv-cam-on" role="status">
      <strong>🎉 Cảm ơn {ten} đã góp mẹo!</strong>
      <span>Cả nhà sẽ thấy trên 📢 Biết gì chưa? trong {NGAY_KHEN} ngày.</span>
      <button className="mv-cam-on-dong" onClick={onDong} aria-label="Đóng">✕</button>
    </div>
  );
}

function MeoVat({ user }) {
  const { id } = useParams();
  const dieuHuong = useNavigate();
  const laAdmin = user?.role === "admin";

  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);
  const [loiTai, setLoiTai] = useState(false);
  const [tim, setTim] = useState("");
  const [loc, setLoc] = useState("");

  // Biểu mẫu: null = đóng · "viet" · { sua: id }
  const [moForm, setMoForm] = useState(null);
  const [form, setForm] = useState(FORM_TRONG);
  const [tepMoi, setTepMoi] = useState(null);
  const [boAnhCu, setBoAnhCu] = useState(false);
  const [dangGui, setDangGui] = useState("");

  const [camOn, setCamOn] = useState(false);
  const [xemAnh, setXemAnh] = useState(null);
  const henCamOn = useRef(null);

  const { bao, noiBao } = useThongBao(5000);

  const taiLai = useCallback(async () => {
    try {
      const d = await fetchData("meo-vat");
      setDs(Array.isArray(d) ? d : []);
      setLoiTai(false);
    } catch (err) {
      // Tải hỏng KHÔNG gộp vào "sổ tay còn trống" — nói sai sự thật (bài học N5).
      setLoiTai(true);
    } finally {
      setDangTai(false);
    }
  }, []);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  useEffect(() => () => henCamOn.current && clearTimeout(henCamOn.current), []);

  // Đổi mẹo đang xem (bấm từ Bảng tin, bấm Quay lại) thì đóng biểu mẫu, lên đầu trang.
  useEffect(() => {
    setMoForm(null);
    window.scrollTo(0, 0);
  }, [id]);

  const moViet = () => {
    setForm(FORM_TRONG);
    setTepMoi(null);
    setBoAnhCu(false);
    setCamOn(false);
    setMoForm("viet");
  };

  const moSua = (m) => {
    setForm({ tieu_de: m.tieu_de || "", phan_loai: m.phan_loai || "", noi_dung: m.noi_dung || "", link: m.link || "" });
    setTepMoi(null);
    setBoAnhCu(false);
    setMoForm({ sua: m.id, anhCu: m.anh_id && !m.anh_da_don ? m.anh_id : null });
  };

  const guiAnhMeo = async (meoId) => {
    setDangGui("Đang thu nhỏ ảnh…");
    const blob = await thuNhoAnh(tepMoi);
    setDangGui(`Đang gửi ảnh… ${veDungLuong(tepMoi.size)} → ${veDungLuong(blob.size)}`);
    await guiAnh(`meo-vat/${meoId}/anh`, blob);
  };

  const luu = async () => {
    // Kiểm ngay để báo liền — máy chủ kiểm lại y hệt.
    if (form.tieu_de.trim() === "") return noiBao("⚠️ Chưa có tiêu đề");
    if (!form.phan_loai) return noiBao("⚠️ Chưa chọn phân loại");
    if (form.link.trim() !== "" && !laLinkHopLe(form.link.trim())) {
      return noiBao("⚠️ Link phải bắt đầu bằng http:// hoặc https://");
    }

    const laSua = moForm && moForm.sua;
    setDangGui("Đang lưu…");
    let meoId = laSua ? moForm.sua : null;
    try {
      if (laSua) {
        await updateData("meo-vat", meoId, form);
      } else {
        meoId = (await addData("meo-vat", form)).id;
      }
    } catch (err) {
      setDangGui("");
      return noiBao(`⚠️ Chưa lưu được${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    }

    // Mẹo ĐÃ LƯU. Ảnh hỏng thì nói rõ là chỉ hỏng ảnh, mẹo vẫn còn.
    let loiAnh = null;
    try {
      if (tepMoi) await guiAnhMeo(meoId);
      else if (laSua && boAnhCu && moForm.anhCu) await deleteData(`meo-vat/${meoId}`, "anh");
    } catch (err) {
      loiAnh = err.nguoiDung ? err.message : err.chiTiet || "không gửi được ảnh";
    }

    setDangGui("");
    setMoForm(null);
    await taiLai();

    if (loiAnh) {
      noiBao(`⚠️ Đã lưu mẹo, nhưng ảnh chưa lên: ${loiAnh}. Bấm ✏️ Sửa để gắn lại.`, 9000);
    } else if (laSua) {
      noiBao("✅ Đã lưu thay đổi");
    }
    if (laSua) {
      dieuHuong(`/meo-vat/${meoId}`);
    } else {
      // Viết mới → về danh sách, mẹo vừa viết nằm trên cùng, kèm lời cảm ơn.
      dieuHuong("/meo-vat");
      setCamOn(true);
      if (henCamOn.current) clearTimeout(henCamOn.current);
      henCamOn.current = setTimeout(() => setCamOn(false), 10000);
    }
  };

  const xoa = async (m) => {
    if (!hoiXoa("mẹo", m.tieu_de)) return;
    try {
      await deleteData("meo-vat", m.id);
      noiBao(`🗑️ Đã xoá mẹo "${m.tieu_de}"`);
      await taiLai();
      dieuHuong("/meo-vat");
    } catch (err) {
      noiBao(`⚠️ Chưa xoá được${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    }
  };

  if (dangTai) return <DangTai gi="sổ tay mẹo vặt" />;

  // ================= Biểu mẫu Viết / Sửa =================
  if (moForm) {
    const laSua = Boolean(moForm.sua);
    return (
      <div className="card">
        <h3>{laSua ? "✏️ Sửa mẹo" : "➕ Viết một mẹo"}</h3>
        <ThongBao bao={bao} />
        <FormMeo
          form={form}
          onDoi={(cot, v) => setForm((f) => ({ ...f, [cot]: v }))}
          anhCu={moForm.anhCu}
          tepMoi={tepMoi}
          onChonTep={(tep) => {
            setTepMoi(tep);
            setBoAnhCu(false);
          }}
          boAnhCu={boAnhCu}
          onBoAnhCu={() => {
            setTepMoi(null);
            setBoAnhCu(true);
          }}
          dangGui={dangGui}
          onLuu={luu}
          onThoi={() => setMoForm(null)}
          laSua={laSua}
        />
      </div>
    );
  }

  // ================= Xem một mẹo =================
  if (id) {
    const m = ds.find((x) => String(x.id) === id);
    return (
      <div className="card">
        <Link to="/meo-vat" className="mv-quay-lai">← Mẹo vặt</Link>
        <ThongBao bao={bao} />
        {!m ? (
          <p className="db-trong">
            {loiTai
              ? "⚠️ Không tải được sổ tay. Bấm F5 thử lại."
              : "Không tìm thấy mẹo này — có thể người viết đã xoá."}
          </p>
        ) : (
          <article className="mv-xem">
            <h3 className="mv-xem-tieu-de">{m.tieu_de}</h3>
            <span className="mv-chip">{tenLoai(m.phan_loai)}</span>

            {m.anh_id && !m.anh_da_don && (
              <AnhCoKhoa
                anhId={m.anh_id}
                moTa={m.tieu_de}
                className="mv-anh-to"
                onClick={() => setXemAnh(m)}
              />
            )}
            {m.anh_id && m.anh_da_don && <span className="anh-da-cat">🗂️ ảnh đã cất</span>}

            <NoiDungMeo chu={m.noi_dung} />

            {m.link && (
              <a href={m.link} target="_blank" rel="noopener noreferrer" className="mv-link mv-link-rieng">
                🔗 {m.link}
              </a>
            )}

            <div className="mv-chan">
              <span>
                {m.ten_nguoi_viet || "?"} · {m.ngay_viet}
                {m.da_sua && <span className="dx-da-sua"> · đã sửa</span>}
              </span>
              {(laAdmin || m.user_id === user.id) && (
                <span className="db-nut">
                  <button onClick={() => moSua(m)} className="btn-edit" title="Sửa">✏️</button>
                  <button onClick={() => xoa(m)} className="btn-delete" title="Xoá">🗑️</button>
                </span>
              )}
            </div>
          </article>
        )}
        {xemAnh && (
          <XemAnh anhId={xemAnh.anh_id} tieuDe={xemAnh.tieu_de} bieuTuong="💡" onDong={() => setXemAnh(null)} />
        )}
      </div>
    );
  }

  // ================= Danh sách =================
  const hienThi = ds.filter((m) => (!loc || m.phan_loai === loc) && khopTim(m, tim));

  return (
    <div className="card">
      <div className="mv-dau">
        <h3>💡 Mẹo vặt</h3>
        <button className="btn-add mv-nut-viet" onClick={moViet}>➕ Viết mẹo</button>
      </div>
      <ThongBao bao={bao} />
      {camOn && <LoiCamOn ten={user.full_name} onDong={() => setCamOn(false)} />}

      <p className="db-mo-dau">
        Sổ tay chung của cả nhà — mẹo nấu ăn, sửa đồ, giặt giũ… Ai biết mẹo gì hay thì góp vào.
      </p>

      {loiTai && <p className="reminder-loi">⚠️ Không tải được sổ tay. Bấm F5 thử lại.</p>}

      {ds.length > 0 && (
        <>
          <input
            type="search"
            value={tim}
            onChange={(e) => setTim(e.target.value)}
            placeholder="🔎 Tìm mẹo — gõ không dấu cũng được"
            className="db-o-tim"
          />
          <div className="mv-hang-loc" role="group" aria-label="Lọc theo loại">
            <button className={`mv-loc ${loc === "" ? "mv-loc-bat" : ""}`} onClick={() => setLoc("")}>
              Tất cả
            </button>
            {PHAN_LOAI.map((p) => (
              <button
                key={p.ma}
                className={`mv-loc ${loc === p.ma ? "mv-loc-bat" : ""}`}
                onClick={() => setLoc(loc === p.ma ? "" : p.ma)}
              >
                {p.ten}
              </button>
            ))}
          </div>
        </>
      )}

      {!loiTai && ds.length === 0 && (
        <p className="db-trong">
          Sổ tay còn trống. Bấm <strong>➕ Viết mẹo</strong> để góp mẹo đầu tiên — cả nhà sẽ thấy lời cảm ơn trên
          Bảng tin.
        </p>
      )}

      {ds.length > 0 && hienThi.length === 0 && (
        <p className="db-trong">
          Không có mẹo nào khớp{tim.trim() ? ` “${tim.trim()}”` : ""}
          {loc ? ` trong loại ${tenLoai(loc)}` : ""}.
        </p>
      )}

      {hienThi.length > 0 && (
        <ul className="mv-ds">
          {hienThi.map((m) => (
            <TheMeo key={m.id} m={m} onMo={() => dieuHuong(`/meo-vat/${m.id}`)} />
          ))}
        </ul>
      )}
    </div>
  );
}

export default MeoVat;
